export enum ModuleTokens {
  Name = 'ticketPriceOffer'
}
